import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const TopGraphic = () => (
  <StaticQuery
    query={graphql`
      query {
        placeholderImage: file(relativePath: { eq: "graphics/investors_top_graphic.png" }) {
          childImageSharp {
            fluid(maxWidth: 3000) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
      }
    `}
    render={data => <Img fluid={data.placeholderImage.childImageSharp.fluid} imgStyle={{'objectFit': 'contain', left: '50%', transform: 'translateX(-50%)'}} alt="Use MProfit to manage your investments"/>}
  />
)
export default TopGraphic
